import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  Text,
  Button,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  TableBody,
  RangeInput,
} from "grommet";
import API_URL from "../../config/config";
import axios from "axios";
import { Info } from "grommet-icons";
export const QuizFields = ({ onSubmit, productCount, data, assessment_id }) => {
  const [LocalProductCount, setProductCount] = useState(productCount);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [skills, setSkills] = useState([]);
  const [skillDistribution, setSkillDistribution] = useState([]);
  const [isLoadingSkills, setIsLoadingSkills] = useState(true);
  const [skillsError, setSkillsError] = useState(null);
  const [skillQuestionCounts, setSkillQuestionCounts] = useState([]);
  const [submittedData, setSubmittedData] = useState(null);
  const userId = data;
  const a_id = assessment_id;

  const initializeSkillQuestionCounts = () => {
    if (!skills.length || !skillDistribution.length) return; // Wait until both skills and distribution are available

    console.log("Initializing skill question counts", skillDistribution);
    console.log("Skills", skills);

    const counts = skills.map((skill) => {
      // Find the matching skill by sub_product_id
      const matchingSkill = skillDistribution.find(
        (item) => item.sub_product_id === skill.sub_product_id,
      );
      console.log("Matching skill", matchingSkill);
      return matchingSkill ? matchingSkill.count : 0; // Default to 0 if no match
    });
    setSkillQuestionCounts(counts);
  };

  const handleSubmit = () => {
    setIsSubmitting(true);

    const skillDistribution = skills.map((skill, index) => ({
      skillId: skill.sub_product_id,
      count: skillQuestionCounts[index] || 0,
    }));

    setSubmittedData(skillDistribution);

    onSubmit({
      totalQuestions: skillQuestionCounts.reduce((a, b) => a + b, 0),
      skillDistribution,
    });

    setIsSubmitting(false);
  };

  useEffect(() => {
    const fetchSkills = async () => {
      try {
        console.log("Fetching skills for user", assessment_id);
        const response = await axios.get(
          `${API_URL}/manager/getUserProductSkills/${a_id}`,
        );

        console.log("Response", response);
        const data = response.data.skills;
        console.log("Skills RES", data);
        setSkills(data);
        setIsLoadingSkills(false);
      } catch (error) {
        setSkillsError(error.message);
        setIsLoadingSkills(false);
      }
    };

    const fetchSkillDistribution = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/manager/skillDistribution/${a_id}`,
        );

        console.log("Skill distribution", response);
        const distribution = response.data.skillDistribution;
        setSkillDistribution(distribution);
      } catch (error) {
        console.error("Error fetching skill distribution:", error);
      }
    };

    fetchSkills();
    fetchSkillDistribution();
  }, [a_id]);

  // Re-run initialization when either skills or skill distribution is updated
  useEffect(() => {
    initializeSkillQuestionCounts();
  }, [skills, skillDistribution]);

  return (
    <Box
      pad={{ vertical: "medium", horizontal: "large" }}
      gap="medium"
      align="center"
    >
      <Heading level="2">View assessment details</Heading>

      {isLoadingSkills ? (
        <Text>Loading skills...</Text>
      ) : skillsError ? (
        <Text color="status-critical">Error: {skillsError}</Text>
      ) : (
        <Box width="large" margin={{ bottom: "medium" }}>
          {/* <Box
            pad="medium"
            background="light-2" // You can customize this as per your design
            round="small"
            margin="medium"
          >
            <Text weight="bold">
              <Info color="brand" /> Please select up to 10 questions you would
              like to answer for each skill. <br />
              The more questions you answer, the more accurate the digital
              skills advisor will be in determining a recommendation.
            </Text>
          </Box> */}
          <Table>
            <TableHeader>
              <TableRow>
                <TableCell scope="col" border="bottom">
                  <Text weight="bold">Skill(s)</Text>
                </TableCell>
                <TableCell scope="col" border="bottom">
                  <Text weight="bold">Number of questions</Text>
                </TableCell>
              </TableRow>
            </TableHeader>
            {/* <TableBody>
              {skills.map((skill, index) => (
                <TableRow key={skill.sub_product_id}>
                  <TableCell>
                    {skill.product_name} - {skill.sub_product_name}
                  </TableCell>
                  <TableCell>
                    <Box direction="row" align="center" gap="small">
                      <RangeInput
                        value={skillQuestionCounts[index] || 0}
                        min={1}
                        max={10} // Max 10 questions per skill
                        disabled // Disable the slider to make it static
                      />
                      <Text>{skillQuestionCounts[index] || 0} questions</Text>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody> */}
            <TableBody>
              {skills.map((skill, index) => (
                <TableRow key={skill.sub_product_id}>
                  <TableCell>
                    {skill.product_name} - {skill.sub_product_name}
                  </TableCell>
                  <TableCell>
                    <Box
                      direction="row"
                      align="center"
                      justify="between"
                      style={{ width: "100%" }}
                    >
                      <Text>{1}</Text> {/* Minimum number */}
                      <Box
                        style={{
                          flex: 1,
                          margin: "0 10px",
                          position: "relative",
                        }}
                      >
                        {" "}
                        {/* Flex container for the slider */}
                        <RangeInput
                          value={skillQuestionCounts[index] || 0}
                          min={1}
                          max={10} // Max 10 questions per skill
                          disabled // Disable the slider to make it static
                        />
                        <Text alignSelf="center">
                          {skillQuestionCounts[index] || 0} questions
                        </Text>
                      </Box>
                      <Text>{10}</Text> {/* Maximum number */}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      )}

      {skills.length >= 2 ? (
        <Text weight="bold">
          Total Number of Questions:{" "}
          {skillQuestionCounts.reduce((a, b) => a + b, 0)}
        </Text>
      ) : null}

      <Box width="medium" pad="medium">
        <Button
          primary
          onClick={handleSubmit}
          label={isSubmitting ? "Starting Assessment..." : "Continue"}
          disabled={isSubmitting}
        />
      </Box>

      {submittedData && (
        <Box margin={{ top: "medium" }}>
          <Heading level="4">Submitted Skill Distribution</Heading>
          <Table>
            <TableHeader>
              <TableRow>
                <TableCell scope="col">
                  <Text>Skill ID</Text>
                </TableCell>
                <TableCell scope="col">
                  <Text>Question Count</Text>
                </TableCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {submittedData.map((item) => (
                <TableRow key={item.skillId}>
                  <TableCell>{item.skillId}</TableCell>
                  <TableCell>{item.count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      )}
    </Box>
  );
};
